import React, { useEffect, useRef, useState } from "react";
import { Tooltip, Popover, Modal, Dropdown, Menu } from 'antd';
import styles from "./scss/archieve.module.scss";
import statusimg from "../../../styles/images/profile-status-icon.svg";
import { URAvatarGroup } from "../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../shared/widgets/avatarGroup/statusDot";
import { useSelector } from "react-redux";
import { leftsideChats, initialStateModel, chats, recentChatSocketReducerStateModel } from "../../../models/model";
import { Cookie, getcontactDetail, LeftSavedChatClear } from "../../../base/utils";
import store from "../../../context/store/store";
import { ChatService } from "../../../base/chatService";
import { URChatLeftSkeleton } from "../../../shared/widgets/skeletonLoading/chatLeftSkeleton";
import { getChatSummary, toastInformation, userStatusColor } from "../../../base/callService/common";
import ProfileAvatarGroup from "./profileavatargroup";
import { HighlightInner } from "../../contacts/rightsidebar/highlight";
import moment from 'moment';
import { StatusTag } from "../../../shared/widgets/statusTag";
import { useHistory } from "react-router";
import { SocketChatService } from "../../../base/socketChatService";
import { userInfo } from "../../../base/socketChatService/utils";
import { URButton } from "../../../shared/widgets/button";
import _ from "lodash";
import { updateSettingStatus } from "../../../base/socketChatService/newChat";
// type RecentChatState={
//   limit:any;
//   offset:any;
// }
type RecentChatState = {

  isDelete: boolean;

  deleteData: any;
  deleteChat: any;
}

export default function ArchieveLists(props: any, chats:any,searchContactList: any) {

  const contactList: leftsideChats = useSelector((state: initialStateModel) => state.recentchatReducer);
  const [ArchiveModal, setArchiveModal] = useState<RecentChatState>({ isDelete: false, deleteData: {}, deleteChat: {} })
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  let { unArchivePageLoad, isArchivePaginationStop } = contactList;
  let { userdetails }: any = useSelector((state: initialStateModel) => state.loginReducer);
  const history = useHistory();
  const { recentChatList, recentLoading }: recentChatSocketReducerStateModel =
  useSelector((state: initialStateModel) => state.chatSocketRecentReducerState);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [storeAiContactDetails, setStoreAiContactDetails] = useState<any>({});
  const [closeAi, setCloseAi] = useState<boolean>(false);
  const [mount, setMount] = useState<boolean>(false);
  let { planBased } = store.getState().meetingReducer;
  let allContacs: any = store.getState().contactReducer;
  const recentChatArray = Object.values(recentChatList);
  let {chatSummary}:any=store.getState().chatReducer;
  let socketService = useRef<any>(null);

  const setFilteredLayer = () => {
    props.setFilteredLayer("default");
  };
  const chatSocket = new SocketChatService(userInfo().fromID, userInfo().domainId);

  useEffect(() => {
    if (!mount) {
      const userInfo: any = Cookie.get();
      const userInfosess: any = sessionStorage.getItem("userinfo");
      if (userInfosess) {
        const cookieData = JSON.parse(userInfosess);
        socketService.current = new SocketChatService(cookieData.sip_login_id, cookieData.domain_id);
        setMount(true);

      }
    }

  }, [searchContactList, allContacs, recentLoading, recentChatArray,JSON.stringify(chatSummary)]);

  useEffect(() => {
    // {Unread Chat Summary}
    const unreadChatFeature = planBased.find((item:any) => item.featureid === 479);
    if (unreadChatFeature && unreadChatFeature.value1 === "Yes") {
      setIsButtonDisabled(true); 
    } else {
      setIsButtonDisabled(false); 
    }
  }, [planBased]); 

  const Delete = (data: any) => {
    let contactObject: any = store.getState().contactReducer;
    let workContact = contactObject?.workContactsnew;
    let teamContact = contactObject?.teamContacsnew;
    let toContact = data.type === 1 ? workContact[data?.to] : teamContact[data?.chatId];
    setArchiveModal({ ...ArchiveModal, isDelete: true, deleteData: toContact, deleteChat: data })
  };

  const handleScroll = (e: any) => {
    const bottom = e.target.scrollHeight - Math.round(e.target.scrollTop) === e.target.clientHeight;
    if (bottom && isArchivePaginationStop) {
      // ChatService.recentArchivePagination(pagination.limit,pagination.offset);
      // setPagination({...pagination,limit:pagination.limit+10, offset:pagination.offset});
    }
  };
  const handleCancel = () => {
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })
  }
  const deleteAction = () => {
    let chatDetails = {
      chatId: ArchiveModal?.deleteChat?.chatId,
      settingsKey: "isDeleted",
      status: 1
    }
    chatSocket.updateRecentChatSettings(chatDetails);
    LeftSavedChatClear();
    setArchiveModal({ ...ArchiveModal, isDelete: false, deleteData: {}, deleteChat: {} })
    toastInformation("1 Chat Deleted", "success");
  };

  const openConversation = (contactsDetail: any, contact: any) => {
    ChatService.openChatWindow(contactsDetail, history, contact);
    chat_reducer.isWindowSlide && ChatService.rightSideToogle();
  }
  let teamMemberarrayforImage: any = [];

  const aiOptions=(type:any)=>{
    if(type === "markread"){
      const timer = setTimeout(() => {
        socketService?.current?.markAsRead(storeAiContactDetails.contact);
        let chatDetails = {
          chatId: storeAiContactDetails.contact?.chatId,
          settingsKey: "markRead",
          status: 1
        };
        socketService?.current?.toastUndo("", "");
        if (!storeAiContactDetails.contact?.settings?.markRead) {
          storeAiContactDetails.contact.settings.markRead = {};
          storeAiContactDetails.contact.settings.markRead["s" + userdetails?.sip_login_id] = 1;
        }
        else if (storeAiContactDetails.contact?.settings?.markRead?.["s" + userdetails?.sip_login_id] === 0) {
          storeAiContactDetails.contact.settings.markRead["s" + userdetails?.sip_login_id] = 1;
        }
        socketService?.current?.updateRecentChatSettings(chatDetails)
        updateSettingStatus(storeAiContactDetails.contact?.type, storeAiContactDetails.contact?.type === 1 ? storeAiContactDetails.contact?.to : storeAiContactDetails.contact?.chatId, storeAiContactDetails.contact?.settings);
      }, 3000);
      socketService.current.toastUndo("Conversation marked as read", timer, 'markRead');
    }else{
      openConversation(storeAiContactDetails.contactsDetail,storeAiContactDetails.contact)
    }
}

  const openAiModal=(e:any)=>{
    setCloseAi(true);
 }
 const closeAiModal=(e:any)=>{
  setCloseAi(false);
}

  const storeAiDetails=(contactsDetail:any, contact:any, index:any, chats:any)=>{
    setStoreAiContactDetails({contactsDetail:contactsDetail,contact:contact,index:index,chats:chats})
    getChatSummary(contactsDetail);
  }

  var len = Array.isArray(searchContactList) && searchContactList?.length > 7 ? Math.ceil((searchContactList?.length / 8)) : 1;
  var random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  const menuai = (
    <>
     {(!_.isEmpty(storeAiContactDetails?.contact?.chatSummary)) &&  closeAi &&
       <div className={styles.menuais}  onClick={(e: any) => e.stopPropagation()}>
      <><h3>AI Summary <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" onClick={(e)=>closeAiModal(e)}>
        <path d="M6.70693 6.00003L11.8005 0.906301C11.9959 0.710968 11.9959 0.394568 11.8005 0.199301C11.6052 0.00403433 11.2888 0.00396764 11.0935 0.199301L5.99993 5.29303L0.906326 0.199234C0.710993 0.00390103 0.394593 0.00390103 0.199326 0.199234C0.00405926 0.394568 0.00399258 0.710968 0.199326 0.906234L5.29293 5.99997L0.199326 11.0937C0.00399258 11.289 0.00399258 11.6054 0.199326 11.8007C0.296993 11.8984 0.424926 11.9472 0.552859 11.9472C0.680793 11.9472 0.808726 11.8984 0.906393 11.8007L5.99999 6.70697L11.0936 11.8007C11.1913 11.8984 11.3192 11.9472 11.4471 11.9472C11.5751 11.9472 11.703 11.8984 11.8007 11.8007C11.996 11.6054 11.996 11.289 11.8007 11.0937L6.70693 6.00003Z" fill="#757676" />
      </svg></h3>
      <div className={styles.profileai}>
        <div className={styles.profileaileft}>
        {storeAiContactDetails.contactsDetail?.team_id ?
                            <ProfileAvatarGroup key={0} contactDetail={storeAiContactDetails.contactsDetail} profileSize={38} randomColor={[1]}></ProfileAvatarGroup>
                       :
                       <URAvatarGroup className={` ashavatorcnl lefts size28 colorBG${random_color[0]}`}
                       profileInfo={<>
                    
                         {
                           storeAiContactDetails?.contactsDetail?.profile_image_thumbnail ?
                             <img src={storeAiContactDetails?.contactsDetail?.profile_image_thumbnail} alt="" /> :
                             storeAiContactDetails?.contactsDetail?.profile_url ?
                               <img src={storeAiContactDetails?.contactsDetail?.profile_url} alt="" />
                               : <span>{storeAiContactDetails?.contactsDetail?.caller_id?.charAt(0)?.toUpperCase()}</span>}

                         {/* <URStatusDot className={userStatusColor(link.fromDetails?.user_status, 'small')} /> */}

                        
                       </>}
                     />}
        </div>
        <div className={styles.profileairight}>{storeAiContactDetails?.contactsDetail?.team_id ? storeAiContactDetails?.contactsDetail?.team_name : storeAiContactDetails?.contactsDetail?.caller_id}</div>
      </div>
      <p>{`${storeAiContactDetails?.contact?.chatSummary}`}</p>
      <div className={styles.profileaibottom}>
      <button onClick={()=>aiOptions("openchat")}>Open chat</button>
        <button onClick={()=>aiOptions("markread")}>Mark as read</button>
      </div></>
    </div>
    }
    </>
  );


  try {
    return (
      <>
        <div className={`fadeIn ${styles.archievelistmain}`}>
          <div className={styles.rightbartop}>
            <div className={styles.lefts}>
              Archived <b>{"("+ props.defaultContacts?.searchArchive?.length +")"}</b>
            </div>
            <div className={styles.rights}>
              <Tooltip placement="top" title="Close">
                <span className="icon_close" onClick={setFilteredLayer}></span></Tooltip>
            </div>
          </div>
          <div className={styles.rightbarbottom} onScroll={handleScroll}>
            {props?.defaultContacts?.searchArchive?.map((contact: any, index: number) => {

              let contactObject: any = store.getState().contactReducer;
              let workContact = contactObject?.workContactsnew;
              let teamContact = contactObject?.teamContacsnew;
              let toContact = parseInt(contact.to);
              let contactsDetail = contact  && contact.type === 1 ? workContact[toContact] : teamContact["con" + contact.chatId];
              if (contact?.type !== 1 && contactsDetail) {

                contactsDetail.teammembersdetails = contact.teammembersdetails || "";
              }
              let teamMemberNames: any = [];
              if (contact?.contactDetail?.team_id) {
                teamMemberarrayforImage = contact?.contactDetail?.team_id && contact?.contactDetail?.team_members &&
                  contact?.contactDetail?.team_members.replace(" ", "").split(',');
                teamMemberarrayforImage?.map((list: any) => {
                  let c_details = getcontactDetail(list);
                  teamMemberNames.push(c_details?.caller_id);
                });
              }
              const menu = (
                <ul onClick={(e: any) => e.stopPropagation()}>
                  <Menu>
                    <Menu.Item key={"unarchive"} onClick={()=>props.unArchive(contact)} >Unarchive </Menu.Item>
                    <Menu.Item key={"delete"} onClick={()=>Delete(contact)}>Delete</Menu.Item>
                  </Menu>
                </ul>
              );
              const content = (
                <div className={styles.contactDetailsSec}>
                  <URAvatarGroup className='lefts size82 mr12' key={index}
                    profileInfo={
                      (contactsDetail?.ImageURL !== null && contactsDetail?.ImageURL !== "") ?
                        (<>
                          <img src={contactsDetail?.ImageURL} alt="" />
                          <URStatusDot className={userStatusColor(contactsDetail?.user_status, 'big')} /></>) :
                        (<>
                          <span>{contactsDetail?.first_name?.charAt(0).toUpperCase() + contactsDetail?.last_name?.charAt(0).toUpperCase()} </span>
                          <URStatusDot className={userStatusColor(contactsDetail?.user_status, 'big')} />
                        </>)
                    } />
                  <div className={styles.userDt}>
                    <p className={styles.userName}>{contactsDetail?.caller_id ? contactsDetail?.caller_id : contactsDetail?.team_name}</p>
                    <Tooltip mouseEnterDelay={0.5} placement="top" title={contactsDetail?.is_favourite === 1 ? "Remove Favourite" : 'Add Favourite'}>
                      <span className={contactsDetail?.is_favourite === 1 ? "icon_starfill" : "icon_star"}></span>
                    </Tooltip>
                    <Tooltip mouseEnterDelay={0.5} placement="top" title={contactsDetail?.is_muted === 0 ? "Mute all Notifications" :
                      "Unmute all Notification"} >
                      <span className={contactsDetail?.is_muted === 0 ? "icon_belloutline" : "icon_Notificationsolid"}></span>

                    </Tooltip>
                  </div>
                  <div className={styles.actionIcon}>
                    <div className={styles.callIcon}><span></span> Call</div>
                    <div className={styles.chatIcon}><span></span> Chat</div>
                    <div className={styles.meetIcon}><span></span> Meet</div>
                  </div>
                  <div className={styles.profileDt}>
                    <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
                      <div className={styles.leftsidetxt}>
                        <p>Department</p>
                      </div>
                      <div className={styles.rightsidetxt}>
                        <p>{contactsDetail?.department ? contactsDetail?.department : "--"}</p>
                      </div>
                    </div>
                    <div className={`${styles.rowFlex} ${styles.alignItemCenter}`}>
                      <div className={styles.leftsidetxt}>
                        <p>Extension</p>
                      </div>
                      <div className={styles.rightsidetxt}>
                        <p>{contactsDetail?.ext ? contactsDetail?.ext : ""}</p>
                      </div>
                    </div>
                    <div className={`${styles.rowFlex} `}>
                      <div className={styles.leftsidetxt}>
                        <p>My Numbers</p>
                      </div>
                      <div className={styles.rightsidetxt}>
                        <div className={styles.phoneNumbrtxt}>
                          <Tooltip placement="top" title="Company number">
                            <p>02037827900</p>
                          </Tooltip>
                          <Tooltip placement="top" title="Worktual number">
                            <p>01212190524</p>
                          </Tooltip>
                          <Tooltip placement="top" title="Mobile number">
                            <p>07574198622</p>
                          </Tooltip>
                          <Tooltip placement="top" title="International number">
                            <p>+4368860755414</p>
                          </Tooltip>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.rowFlex} `}>
                      <div className={styles.leftsidetxt}>
                        <p>Email Address</p>
                      </div>
                      <div className={styles.rightsidetxt}>
                        {contactsDetail?.email_id &&
                          <div className={styles.emailtxt}>
                            <Tooltip placement="top" title={contactsDetail?.email_id}>
                              <p>{contactsDetail?.email_id}</p>
                            </Tooltip>
                            {/* 
                       <Tooltip placement="top" title="johnywade.12465@vectone.com">
                          <p>johnywade.johny.wa@vectone.com</p>
                       </Tooltip>
                       */}
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                  {contactsDetail?.status_msg &&
                    <div className={styles.workingStatus}>
                      <StatusTag className='statusTag bgGrey'
                        name={contactsDetail?.status_msg}
                      />
                      <span><img src={statusimg} alt="" /></span>
                    </div>
                  }
                </div>
              );
              return (

                <>
                  <div className={styles.profilelists} key={index} >
                    {/* <div className={styles.hoverdiv}>
                      <ul>
                        <li onClick={() => props.unArchive(contact)}>
                          <Tooltip mouseEnterDelay={0.5} placement="top" title="UnArchive"><span className="icon_unarchivefull"></span></Tooltip></li>
                        <li onClick={() => Delete(contact)}>
                          <Tooltip mouseEnterDelay={0.5} placement="top" title="Delete"><span className="icon_delete"></span></Tooltip></li>
                      </ul>
                    </div> */}
                    <div className={styles.profileDetailspop}>
                      {!contactsDetail?.team_id ?
                        <Popover placement="bottomRight" content={content} trigger="click" overlayClassName="contactDetailspp">
                          <h4 title="View contact details">
                            <ProfileAvatarGroup key={index} contactDetail={contactsDetail} profileSize={38} randomColor={[index + 1]}></ProfileAvatarGroup>
                          </h4>
                        </Popover> :
                        <ProfileAvatarGroup key={index} contactDetail={contactsDetail} profileSize={38} randomColor={[index + 1]}></ProfileAvatarGroup>}
                    </div>

                    <div onClick={() => openConversation(contactsDetail, contact)} className={styles.middle}>
                      <h4>
                        <HighlightInner content={contactsDetail?.caller_id ? contactsDetail?.caller_id : contactsDetail?.team_name}
                          searchedData={props?.defaultContacts?.searchText}></HighlightInner>
                      </h4>


                      {<p >{contact?.lastmessage?.from?.toString() === userdetails.sip_login_id.toString() &&
                        <span className={contact && contact?.lastmessage
                          && contact?.lastmessage?.readStatus === 1 ?
                          "msgRead icon_doubleclick" : contact?.lastmessage?.deliveryStatus === 8 ? "icon_doubleclick" : "sentMsg"}></span>}
                        {contact?.lastmessage && (contact?.lastmessage?.message?.messageType === "IMAGE" ||
                          contact?.lastmessage?.message?.messageType === "FILE") && <span className="icon_image"></span>}
                        {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "TASK" && <span className="icon_task"></span>}
                        {contact?.lastmessage && contact?.lastmessage?.message?.messageType === "EVENTS" && <span className="icon_event"></span>}{contact?.lastmsgText?.replace(/(<([^>]+)>)/gi, " ")}</p>}

                    </div>
                    <div className={styles.rights}>
                      <span>{moment(contact?.createdAt).format('hh:mm A')}</span>
                      <div className={styles.rightsbottom}>
                      {contact?.unreadCount > 0 && <><div className={styles.unReadMsgCount}> {contact?.unreadCount}</div>
                            <Dropdown className={(isButtonDisabled === false) ? 'disabledIcon':''} overlay={menuai} trigger={['click']} onClick={(e: any) => e.stopPropagation()}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none" onMouseEnter={()=>storeAiDetails(contactsDetail, contact, index, chats ? chats + "Recent" : "")} onClick={openAiModal}>
                                <path d="M11.6964 1.64498L10.8376 0.79678C10.6427 0.604313 10.3888 0.50818 10.1349 0.50818C9.87689 0.508247 9.61903 0.607447 9.42336 0.805513L1.02563 9.30805C0.637492 9.70098 0.641492 10.3341 1.03443 10.7222L1.89329 11.5705C2.08816 11.763 2.34209 11.8591 2.59596 11.8591C2.85396 11.8591 3.11183 11.7598 3.30749 11.5618L11.7052 3.05925C12.0933 2.66631 12.0894 2.03305 11.6964 1.64498ZM2.59603 10.859L1.73716 10.0108L7.62916 4.04465L8.48989 4.89158L2.59603 10.859ZM9.19256 4.18011L8.33183 3.33311L10.134 1.50831L10.1349 1.50825L10.9938 2.35645L9.19256 4.18011Z" fill="#575CFF" />
                                <path d="M11.8963 8.85165C11.9608 8.89491 11.9931 8.94831 11.9931 9.01298C11.9931 9.07751 11.9608 9.13151 11.8963 9.17431L10.6054 9.69065L10.089 10.9816C10.0456 11.0461 9.99223 11.0784 9.92756 11.0784C9.86303 11.0784 9.80916 11.046 9.76623 10.9816L9.24989 9.69065L7.95896 9.17431C7.89443 9.13151 7.86216 9.07751 7.86216 9.01298C7.86216 8.94831 7.89449 8.89491 7.95896 8.85165L9.24989 8.33518L9.76623 7.04425C9.80916 6.97971 9.86303 6.94758 9.92756 6.94758C9.99223 6.94758 10.0456 6.97978 10.089 7.04425L10.6054 8.33518L11.8963 8.85165Z" fill="#575CFF" />
                                <path d="M4.04036 3.11425C4.10489 3.15751 4.13716 3.21091 4.13716 3.27558C4.13716 3.34011 4.10483 3.39411 4.04036 3.43691L2.74943 3.95325L2.23309 5.24418C2.18969 5.30871 2.13629 5.34098 2.07163 5.34098C2.00709 5.34098 1.95323 5.30865 1.91029 5.24418L1.39396 3.95325L0.103026 3.43691C0.0384923 3.39411 0.00622559 3.34011 0.00622559 3.27558C0.00622559 3.21091 0.0385589 3.15751 0.103026 3.11425L1.39396 2.59778L1.91029 1.30685C1.95323 1.24231 2.00709 1.21018 2.07163 1.21018C2.13629 1.21018 2.18969 1.24238 2.23309 1.30685L2.74943 2.59778L4.04036 3.11425Z" fill="#575CFF" />
                                <path d="M7.22996 1.39658C7.27249 1.42511 7.29383 1.46031 7.29383 1.50298C7.29383 1.54551 7.27249 1.58111 7.22996 1.60938L6.37876 1.94985L6.03829 2.80105C6.00969 2.84358 5.97443 2.86491 5.93183 2.86491C5.88929 2.86491 5.85376 2.84358 5.82543 2.80105L5.48496 1.94985L4.63376 1.60938C4.59123 1.58118 4.56989 1.54551 4.56989 1.50298C4.56989 1.46038 4.59123 1.42511 4.63376 1.39658L5.48496 1.05605L5.82543 0.204847C5.85376 0.162313 5.88929 0.141113 5.93183 0.141113C5.97443 0.141113 6.00969 0.162313 6.03829 0.204847L6.37876 1.05605L7.22996 1.39658Z" fill="#575CFF" />
                              </svg>
                            </Dropdown>
                            
                            </>}
                      {contact?.unreadCount === 0 && contact?.settings?.markRead && contact?.settings?.markRead["s" + userdetails?.sip_login_id] === 2 && <span className={styles.unreadDot}></span>}
                      <Dropdown overlay={menu} placement="bottomRight" trigger={['click']} onClick={(e: any) => e.stopPropagation()}>
                        <span className={` leftmenudrops ${"icon_down-arrow"} ${styles.menudrop}`}
                          onClick={e => e.preventDefault()}>
                        </span>
                      </Dropdown>
                      </div> 
                    </div>
                  </div></>
              );
            })}
            {/*  {archiveContact.map((contact:any)=>{
            <>
              <div className={styles.profilelists}>
                <div className={styles.hoverdiv}>
                  <ul>
                    <li><Tooltip placement="top" title="UnArchieve"><span className="icon_task"></span></Tooltip></li>
                    <li><Tooltip placement="top" title="Delete"><span className="icon_delete"></span></Tooltip></li>
                  </ul>
                </div>
                <URAvatarGroup className='lefts size38 three'
                  profileInfo={<><span>A</span><span>B</span><span>C</span></>}/>
                <div className={styles.middle}>
                  <h4>Diana Bailey</h4>
                  <p>Good to meet you!</p>
                </div>
                <div className={styles.rights}>
                  <span>Yesterday</span>
                </div>
              </div>
            </>
            ;})} */}
            {unArchivePageLoad && ([1].map((item: any, index: any) => (
              <URChatLeftSkeleton width={100} key={index} />)))}
          </div>
        </div>
        <Modal visible={ArchiveModal.isDelete}
          className={`${styles.clearchatmodal} ${"modaloverwrite"}`}>
          <span onClick={handleCancel} className={`icon_close ${styles.cursorTop}`} />
          <h2>Delete this Chat?</h2>
          <p>You will not be able to retrieve this conversation history with {ArchiveModal?.deleteData?.team_id ?
            ArchiveModal?.deleteData?.team_name :
            ArchiveModal?.deleteData?.caller_id} once you delete the chat</p>
          <div className={styles.footersection}>
            <URButton className={styles.cancelbtn} onClick={handleCancel} name="Cancel"></URButton>
            <URButton className={styles.deletebtn} onClick={deleteAction} name="Delete Chat"></URButton>
          </div>
        </Modal>

      </>
    );
  } catch (e) {
    return <p style={{ color: 'red' }}>Something went wrong</p>;
  }

};










